import { BASE_URL } from "./core";

interface IQueryParam {
  paramName: string;
  paramValue: string | number | boolean;
}

interface IVariableParams {
  variableName: string;
  variableValue: string | number | boolean;
}

const getUrl = (
  serviceUrl: string,
  variables?: IVariableParams[],
  params?: IQueryParam[]
) => {
  const variablesKeyValuePairs: { [key: string]: string | number | boolean } =
    {};

  variables?.forEach((item) => {
    variablesKeyValuePairs[item.variableName] = item.variableValue;
  });

  serviceUrl = serviceUrl.replace(/\{(\w+)\}/g, (match, name) => {
    return variablesKeyValuePairs[name].toString();
  });

  let url = `${serviceUrl.startsWith("http") ? "" : BASE_URL}${serviceUrl}`;
  if (params && params.length > 0) {
    const queryParams = new URLSearchParams();
    params.forEach((param) => {
      queryParams.set(param.paramName, param.paramValue.toString());
    });
    url += `?${queryParams.toString()}`;
  }
  return url;
};

export { getUrl };
export type { IQueryParam, IVariableParams };
